const LinkEmptyButton = ({ handleResourceAdd }: { handleResourceAdd: () => void }) => {
  return (
    <button
      className="box-border flex h-[30px] w-full flex-1 items-center rounded-[5px] px-1 text-[14px] font-normal text-placeholder hover:rounded-[5px] hover:bg-w-8-hover"
      onClick={handleResourceAdd}
    >
      <span className="leading-[22px]">Add a link</span>
    </button>
  );
};

export default LinkEmptyButton;
